import type * as React from 'react';
import { PropsWithChildren, ReactNode } from 'react';
import * as style from './style.css';
import { Responsive } from '@cian/ui-kit';

interface IListingWrapperProps {
  pagination: ReactNode;
}

export const ListingWrapper = ({
  children,
  pagination,
}: PropsWithChildren<IListingWrapperProps>): React.JSX.Element => {
  return (
    <div className={style['container']} data-testid="LayoutsListing">
      <div className={style['listing']}>{children}</div>
      <Responsive desktop>
        <div className={style['pagination']}>{pagination}</div>
      </Responsive>
    </div>
  );
};
